/*global angular*/
import './style.less';

import { flatten, intersection, uniq, uniqBy, orderBy } from 'lodash';
import moment from 'moment';
import { defaultEventProjection } from 'assets/projections';

export default function($q, $log, CategoryClass, ApiClass, CoursesClass, $filter, $stateParams, $state) {
  'ngInject';

  $log.debug('Events Filter Component Activated');
  const vm = this;
  vm.$onInit = activate;
  vm.$onChanges = change;

  vm.vendorSearchDisabled = !!$stateParams.vendor_id;

  const setSearch = search => {
    $state.go('.', { ...search, time: moment().valueOf() }, { notify: true, reload: false });
  };

  const setStateParams = () => {
    const {
      author,
      category,
      courseAudience,
      credits,
      deliveryMethod,
      endTime,
      license,
      location,
      name,
      pageSize,
      sortType,
      startTime,
      subjectArea,
      vendor,
      vendor_id
    } = $stateParams;

    let tags = $stateParams.tags;

    if (typeof tags === 'string') {
      tags = [tags];
    }

    vm.authorSearch = author;
    vm.courseAudienceSearch = courseAudience;
    vm.creditsSearch = credits;
    vm.deliveryMethodSearch = deliveryMethod;
    vm.endDate = new Date(endTime);
    vm.license = license;
    vm.licenseCategory = category;
    vm.locationSearch = location;
    vm.nameSearch = name;
    vm.pageSize = !isNaN(pageSize) ? Number(pageSize) : undefined;
    vm.sortType = sortType;
    vm.startDate = new Date(startTime);
    vm.subjectAreaSearch = subjectArea;
    vm.tags = tags;
    vm.vendorSearch = vendor || vendor_id;
  };

  const mapFilter = (queryParams, queryKey, newValue, isDate) => {
    if (newValue || queryKey in $stateParams) {
      queryParams[queryKey] = isDate ? moment(newValue).valueOf() : newValue;
    }

    if (isDate && !queryParams[queryKey]) delete queryParams[queryKey];

    return queryParams;
  };

  const setFilters = () => {
    const search = {};

    [
      ['author', vm.authorSearch],
      ['courseAudience', vm.courseAudienceSearch],
      ['credits', vm.creditsSearch],
      ['deliveryMethod', vm.deliveryMethodSearch],
      ['endDate', vm.endDate, true],
      ['license', vm.license],
      ['category', vm.licenseCategory],
      ['location', vm.locationSearch],
      ['name', vm.nameSearch],
      ['pageSize', vm.pageSize],
      ['sortType', vm.sortType],
      ['startDate', vm.startDate, true],
      ['subjectArea', vm.subjectAreaSearch],
      ['tags', vm.tags],
      ['vendor', vm.vendorSearch]
    ].forEach(queryParam => mapFilter(search, ...queryParam));

    setSearch(search);
  };

  vm.updateDates = () => {
    $state.go('.', { startTime: vm.startDate.getTime(), endTime: vm.endDate.getTime() }, { reload: true });
  };

  function sort(filteredEvents) {
    const defaultSort = '+sortTime';
    return $filter('orderBy')(filteredEvents, vm.sortType || defaultSort);
  }

  vm.update = (events, license, category) => {
    vm.license = license;
    vm.licenseCategory = category;

    if (events) vm.categoryFilterEvents = events;
    if (!vm.categoryFilterEvents) return;
    vm.ngModel = filter(vm.categoryFilterEvents);
    vm.loaded = true;
  };

  function filter(events = []) {
    setFilters();

    const filteredEvent = angular.copy(events).filter(event => {
      let {
        course_name,
        name,
        category_id,
        by,
        credits,
        vendor_id,
        delivery_location,
        delivery_method,
        locations,
        delivery_date,
        hours,
        instructors,
        courseAudience,
        tags
      } = event;

      if (!course_name) course_name = name;

      if (vm.nameSearch && course_name && !course_name.toLowerCase().includes(vm.nameSearch.toLowerCase())) {
        return false;
      }

      if (
        vm.subjectAreaSearch &&
        !flatten([...(hours || []).map(({ category_id }) => category_id), category_id]).includes(vm.subjectAreaSearch)
      ) {
        return false;
      }

      if (
        vm.authorSearch &&
        !flatten([by, ...(instructors || []).map(({ first, last }) => `${first} ${last}`)]).includes(vm.authorSearch)
      ) {
        return false;
      }

      if (vm.tags && vm.tags.length && !intersection(tags, vm.tags).length) {
        return false;
      }

      if (
        vm.creditsSearch &&
        credits != vm.creditsSearch &&
        hours.reduce((total, hour) => (total += Number(hour.credits)), 0) != vm.creditsSearch
      ) {
        return false;
      }

      if (vm.deliveryMethodSearch && delivery_method != vm.deliveryMethodSearch) {
        return false;
      }

      if (vm.vendorSearch && (!vendor_id || vendor_id != vm.vendorSearch)) {
        return false;
      }

      if (vm.courseAudienceSearch && (!courseAudience || courseAudience != vm.courseAudienceSearch)) {
        return false;
      }

      if (
        vm.locationSearch &&
        !flatten([delivery_location, (locations || []).map(({ location }) => location)]).includes(vm.locationSearch)
      ) {
        return false;
      }

      if (vm.startDate) {
        const currentSeconds = new Date(delivery_date).getTime();
        const startSeconds = new Date(vm.startDate).getTime();
        if (currentSeconds < startSeconds) return false;
      }

      if (vm.endDate) {
        const currentSeconds = new Date(delivery_date).getTime();
        const endSeconds = new Date(vm.endDate).getTime();
        if (currentSeconds > endSeconds) return false;
      }

      return true;
    });

    return sort(filteredEvent);
  }

  function cleanCourses(events) {
    return events.map(({ course_name, name, ...event }) => {
      if (name) name = name.trim();
      if (course_name) course_name = course_name.trim();

      name = name || course_name;
      course_name = course_name || name;

      return {
        course_name,
        name,
        ...event
      };
    });
  }

  function getFilters(events) {
    vm.col = 4;
    const authors = flatten(
      events.map(({ by, instructors }) => [by, ...(instructors || []).map(({ first, last }) => `${first} ${last}`)])
    );
    vm.authors = uniq(authors).filter(value => !!value);

    const category_ids = flatten(
      events.map(({ category_id, hours }) => [category_id, ...(hours || []).map(({ category_id }) => category_id)])
    );

    vm.categories = uniq(category_ids)
      .map(category_id => vm.categoriesDict[category_id])
      .filter(value => !!value);

    const creditsArr = events.map(
      ({ credits, hours }) => credits || (hours || []).reduce((total, hour) => (total += Number(hour.credits)), 0)
    );
    vm.credits = uniq(creditsArr).filter(value => value !== undefined);

    vm.deliveryMethods = uniqBy(events, 'delivery_method')
      .map(({ delivery_method }) => delivery_method)
      .filter(value => value !== undefined);

    const tagsArr = flatten(events.map(({ tags }) => tags).filter(arr => arr && arr.length));
    vm.tagsList = uniq(tagsArr).filter(value => value !== undefined);

    vm.vendors = uniqBy(events, 'vendor.name')
      .map(({ vendor }) => vendor)
      .filter(vendor => vendor && vendor.name)
      .filter(value => !!value);

    vm.courseAudiences = uniqBy(events, 'courseAudience')
      .map(({ courseAudience }) => courseAudience)
      .filter(value => !!value);

    if (vm.type !== 'selfStudy') {
      vm.col = 3;
      const locations = events.map(({ delivery_location, locations }) => [
        delivery_location,
        ...(locations || []).map(({ location }) => location)
      ]);
      vm.locations = uniq(flatten(locations)).filter(value => !!value);
    }
  }

  function change() {
    vm.update();
  }

  function activate() {
    vm.error = {};
    vm.loaded = false;
    vm.ngModel = false;

    const timeRange = {
      'filters:startTime': $stateParams.startTime,
      'filters:endTime': $stateParams.endTime
    };

    const projection = defaultEventProjection.reduce((acc, prop) => {
      acc[`projection:${prop}`] = 1;

      return acc;
    }, {});

    const promiseArray = [
      CategoryClass.loadCategories(),
      ApiClass.eventsGet(
        { eventType: false, pastEvents: false },
        {},
        { queryParams: { internal: true, vendor: true, ...timeRange, ...projection } }
      ),
      ApiClass.coursesGet(
        { courseType: false },
        {},
        {
          queryParams: {
            includePassStatus: true,
            internal: true,
            vendor: true,
            filters: JSON.stringify({
              deliveryMethods: CoursesClass.delivery_methods,
              activeOnly: true,
              basic: true
            })
          }
        }
      )
    ];

    return $q
      .all(promiseArray)
      .then(([categories, events, courses]) => {
        vm.events = cleanCourses([...events.data.events, ...courses.data.courses]);
        $log.debug('Events/Courses Data:', vm.events, 'Categories Data:', categories);

        vm.categoriesDict = categories.obj;
        getFilters(vm.events);
        setStateParams();
        vm.ngModel = filter(angular.copy(vm.events));
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: error.status, refresh: activate };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cpeCatalog/filter/controller.js